import { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
import axiosInstances from "../../components/axiosInstance";
import Paginator from "../../components/Paginator";
import InnerNav from "../../components/InnerNav";
import Wrapper from "../../components/Wrapper";
// import { AiFillEdit, AiFillDelete } from "react-icons/ai";
const Winners = ()=>{
    const [winners, setWinners] = useState([]);
    const [page, setPage] = useState(1);
    const [lastPage, setLastPage] = useState(1);
    const [balance, setBalance] = useState(null);
    useEffect(() => {
        (
        async () => {

            const {data} = await axiosInstances.read.get(`lottoWinners?page=${page}`);
            setWinners(data.data);
            setLastPage(data.meta.last_page);
            const balanceValue = data.meta.balance;
            setBalance(balanceValue);
            //console.log(data);

        }
        )();
    },[page]);
    // const del = async (id) =>{
    //     if(window.confirm("Are you sure you want to delete this record?")){
    //         await axios.delete(`topups/${id}`);
    //         setTopups(topups.filter((topups) => topups.id !== id));
    //     }
    // }
    return (
        <Wrapper pageTitle={'Previous Winners'}>
            
            <div className="w-full overflow-hidden rounded-lg shadow-xs">
                <div className="w-full overflow-x-auto">
               
                    <table className="w-full whitespace-no-wrap">
                        <thead>
                            <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800" >
                                <th className="px-4 py-3">#Ref </th>
                                <th className="px-4 py-3">Date </th>
                                <th className="px-4 py-3">MSISDN </th>
                                <th className="px-4 py-3">Draw No </th>
                                
                            </tr>
                            </thead>
                            <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800" >
                                {winners.map((winner)=>{
                                        return(
                                            <tr key={winner.id} className="text-gray-700 dark:text-gray-400">
                                                <td className="px-4 py-5">{winner.id}</td>
                                                <td className="px-4 py-3 text-sm">{winner.date}</td>
                                                <td className="px-4 py-3 text-sm">{winner.msisdn}</td>
                                                <td className="px-4 py-3 text-sm">{winner.draw_number}</td>
                                               
                                                {/* <td className="flex px-4 py-3 text-sm"><Link className="btn btn-sm btn-outline-secondary px-5" to={`/topup/${topup.id}/edit`}><AiFillEdit/> </Link><span className="btn btn-sm btn-outline-secondary" onClick={()=>del(topup.id)}> <AiFillDelete className="text-rose-500 text-lg"/></span></td> */}
                                            </tr>
                                        );
                                    })
                                }
                        </tbody>
                    </table>
                </div>
                <Paginator lastPage={lastPage} pageChanged={setPage} />
            </div>
        </Wrapper>
    );
};
export default Winners;